export const breadcrumbs = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${window.location.origin}${it.path}`,
  })),
});

export const faqPage = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (faqs || [])
    .filter((f) => (f.question || f.q) && (f.answer || f.a))
    .map((f) => ({
      "@type": "Question",
      name: f.question || f.q,
      acceptedAnswer: { "@type": "Answer", text: f.answer || f.a },
    })),
});

export const localBusiness = (settings, testimonials = []) => {
  const c = settings?.contact || {};
  const rated = testimonials.filter((t) => t.rating);
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: settings?.site_name || "Happy Retreats",
    description: settings?.tagline || "",
    url: window.location.origin,
    telephone: c.phone || undefined,
    email: c.email || undefined,
    address: c.address ? { "@type": "PostalAddress", addressLocality: c.address } : undefined,
    image: settings?.logo_url || undefined,
  };
  if (rated.length >= 3) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: (rated.reduce((s, t) => s + t.rating, 0) / rated.length).toFixed(1),
      reviewCount: rated.length,
      bestRating: 5,
    };
  }
  return schema;
};
